import React, { useEffect } from 'react'
import { AboutContainer, BackgroundImage, CTACard, ProfileCircle, ProfileCotainer, SpecialityCard } from './styles';
import { Divider } from '../Manager/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import { EditIconBranding } from '../../utils/icons';
import ProfileDetailsPopup from './ProfileDetailsPopup';
import { GetCoachProfileDetails } from '../../redux/constants/apiConstants';
import { fetchApi, getInitials } from '../../utils/methods';
import { toast } from 'react-toastify';
// import LazyImage from '../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants'; 
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import SkeletonLoder from '../common/skeletonLoder';

function HealthCoachDashboard() {


  // const [profileChecked, setProfileChecked] = React.useState(false);
  const [profilePopup, setProfilePopup] = React.useState(false);
  const [coachData, setCoachData] = React.useState(null);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const loggedInUserID = useSelector((state) => state?.profileData?.userId);
  // const FullName = useSelector((state) => state.profileData?.userName);
  const FullName = coachData ? `${coachData.fname} ${coachData.lname}` : "";
  // const FillName = useSelector((state) => state.profileData);
  const [step, setStep] = React.useState(1);
  const [editState, setEditState] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [isEditable, setIsEditable] = React.useState(false);

  const location = useLocation(); 
  const queryParams = new window.URLSearchParams(location.search);
  const employeeId = queryParams.get("employeeId");

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  
  const setStepForPopup = (stepNumber) => {
    setStep(stepNumber);
  }




  // let DivideScreen = true;
  const openPopup = () => {
    setProfilePopup(true);
  }

  const closePopup = () => {
    setProfilePopup(false);
    setStepForPopup(1);
    setEditState(false)
  }

  const EditProfileDetails = () =>{
    openPopup();
    setStepForPopup(1);
    setEditState(true);
  }

  const EditAboutDetails = () =>{
    openPopup();
    setStepForPopup(4);
    setEditState(true);
  }

  const EditEducationDetails = () =>{
    openPopup();
    setStepForPopup(5);
    setEditState(true);
  }

  const EditFunQuircklyDetails = () =>{
    openPopup();
    setStepForPopup(7);
    setEditState(true);
  }


  const EditCoachBasicDetails = () =>{
    openPopup();
    setStepForPopup(6);
    setEditState(true);
    setDropdownOpen(false);
  }

  const EditExpertiseDetails = () =>{
    openPopup();
    setStepForPopup(2);
    setEditState(true);
  }


  useEffect(() => {
    const coach_id = employeeId || loggedInUserID; // fallback to logged-in user
    if (coach_id) {
      GetCoachProfileData(coach_id);
    }


    if ( !employeeId || (Number(employeeId) === Number(loggedInUserID))) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [employeeId, loggedInUserID]);


  const GetCoachProfileData= async (coach_id) => {

    // let coach_id = employeeId || loggedInUserID;
    const apiUrl = GetCoachProfileDetails + "/" + coach_id;
    try {
      setLoading(true);
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setCoachData(res.data[0]);
        setLoading(false);
        // setWellbeingPillars(res.data.pil
        // lars || []);
      }else{
        toast.error(res.message);
        setLoading(false);
      }
    }
    catch(error){
      window.console.error(error);
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  }


  return (

    <div 
      style={{
        maxWidth: "1246px",
        padding: "25px",
        margin: "auto",
        width: "100%",
      }}>

      {loading ? 
        <SkeletonLoder width={"1246px"} height={"900px"}/> 
        :
        ( <div style={{display:"flex", gap:"20px"}}>
          <div style={{ width: coachData?.health_coach_languages.length && coachData?.health_coach_wellness_pillars.length ? "898px" : "1248px"}}>
            <ProfileCotainer isDataTopMargin={"88px"}   isContainerHeight={coachData?.health_coach_wellness_pillars.length || coachData?.headline ? "428px" : "370px "}>
              <BackgroundImage  cover={coachData?.cover_image ? `${ImageUrl}/${coachData?.cover_image}` : `${ImageUrl}/health-coach/health-coach-banner.png`}>
                {/* <img  className="bg-img" src={`${ImageUrl}/${coachData?.cover_image}`} alt="profile" />  */}
                {coachData?.profile_image!=="profile-Image/default.png" ?<ProfileCircle isDataMargin={"115px"} >
                  <img  className="profile-img" src={`${ImageUrl}/${coachData?.profile_image}`} alt="profile" /> 
                </ProfileCircle>: 
                  <ProfileCircle  isDataMargin={"115px"} ><div className="nameInitials">{getInitials(FullName)}</div></ProfileCircle> }
                 
                {/* {coachData?.profile_image !== "profile-Image/default.png" ? (
                  <LazyImage
                    style={{
                      width: "330.086px;",
                      height: "330.086px;",
                      borderRadius: "173px",
                      border: "8px solid  #FEFEFE",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    src={`${ImageUrl}/${coachData?.profile_image}`}
                  />
                ) : (
                  <NameInitials id="name-initials">
                    {getInitials(coachData?.fname, coachData?.lname)}
                  </NameInitials>
                )} */}
              
              </BackgroundImage>
              {isEditable ? ((coachData?.health_coach_languages.length && coachData?.health_coach_wellness_pillars.length)  || coachData?.headline ? <div className="editIcon"  onClick={()=> EditProfileDetails()} >{EditIconBranding()}</div>:null) : null}
              <div className="user-name">{FullName}</div>
              <div className="certificationDetails">{coachData?.headline}</div>
             
              <div style={{display:"flex", gap:"8px", marginTop:"16px", flexWrap:"wrap",marginLeft:"33px"}}>
                {coachData?.health_coach_wellness_pillars?.map((item)=>(
                  <SpecialityCard key={item.id}>
                    <img className="icon" src={`${ImageUrl}/${item?.icon}`} alt="icon" />
                    {/* <img  className="icon" src={`${ImageUrl}/${coachData?.profile_image}`} alt="profile" />  */}
                    <div className="text">{item.pillar_title}</div>
                  </SpecialityCard>))}
              </div>
  
            </ProfileCotainer>
    
            {coachData?.about_yourself ? <AboutContainer>
              <div className="aboutSubContainer">
                <div className="aboutHeading">About</div>
                {isEditable ? <div onClick={()=> EditAboutDetails()}  className="icon">{EditIconBranding()}</div>:null}
              </div>
              <div className="text">
                {coachData?.about_yourself}
              </div>
      
            </AboutContainer> :
              coachData?.health_coach_wellness_pillars?.length && coachData?.health_coach_languages?.length ?
                <AboutContainer>
                  <div className="aboutSubContainer">
                    <div className="aboutHeading">About</div>
                    {isEditable ? <div onClick={()=> EditAboutDetails()}  className="icon">{EditIconBranding()}</div>:null}
                  </div>
                  <div className="no-Data-Found">No data available</div>
                </AboutContainer> :null}
    
    
            {coachData?.health_coach_education_certification?.length ? 
              <AboutContainer>
                <div className="aboutSubContainer">
                  <div className="aboutHeading">Education & Specialization</div>
                  {isEditable ?  <div  onClick={()=> EditEducationDetails()} className="icon">{EditIconBranding()}</div>:null}
                </div>
                <div className="text">
                  {
                    coachData?.health_coach_education_certification?.map((item)=> item.education_certificate).join(",")
                  }
                </div>
              </AboutContainer>:
              coachData?.health_coach_wellness_pillars?.length && coachData?.health_coach_languages?.length ?
                <AboutContainer>
                  <div className="aboutSubContainer">
                    <div className="aboutHeading">Education & Specialization</div>
                    {isEditable ?  <div  onClick={()=> EditEducationDetails()} className="icon">{EditIconBranding()}</div>:null}
                  </div>
                  <div className="no-Data-Found">No data available</div>
                 
                </AboutContainer> : null}
      
            {(coachData?.spirit_veggie_or_fruit || coachData?.favorite_place_to_vacation || coachData?.wellness_superpower)   ? 
              <AboutContainer>
                <div className="aboutSubContainer">
                  <div className="aboutHeading">Get to Know Me (Fun + Quirky)</div>
                  {isEditable ?<div className="icon"   onClick={()=> EditFunQuircklyDetails()} >{EditIconBranding()}</div>:null}
                </div>
        
                <div className="subHeading">Spirit Veggie or Fruit</div>
                {coachData?.spirit_veggie_or_fruit  ? <div className="text">{coachData?.spirit_veggie_or_fruit}</div> :<div className="no-Data-Found">No data available</div>}
                <Divider isMargin={"16px 0px"}></Divider>
        
                <div className="subHeading">Favorite Place to Vacation</div>
                {coachData?.favorite_place_to_vacation ? <div className="text">{coachData?.favorite_place_to_vacation}</div> :<div className="no-Data-Found">No data available</div>}
                <Divider isMargin={"16px 0px"}></Divider>
        
                <div className="subHeading">Wellness Superpower</div>
                {coachData?.wellness_superpower ? <div className="text">{coachData?.wellness_superpower}</div>   : <div className="no-Data-Found">No data available</div>}
        
              </AboutContainer>: 
              coachData?.health_coach_languages?.length || coachData?.health_coach_wellness_pillars?.length ? (
              // ✅ Case 2: Other data exists but fun facts missing → show “No data yet”
                <AboutContainer>
                  <div className="aboutSubContainer">
                    <div className="aboutHeading">Get to Know Me (Fun + Quirky)</div>
                    {isEditable ?  <div className="icon" onClick={() => EditFunQuircklyDetails()}>
                      {EditIconBranding()}
                    </div>:null}
                  </div>
                  <div className="no-data">No fun facts added yet — click to share one.</div>
                </AboutContainer>
              ) : null}
      
            {coachData?.health_coach_wellness_pillars?.length && coachData?.health_coach_languages?.length  ? null : <CTACard>
              <div className="title">Your Journey Starts Here</div>
              <div className="subTitle">Add your profile details to unlock new client connections and coaching opportunities, while helping your current clients find and engage with you more easily.</div>
              {/* <div className="progressBar"></div> */}
              {/* <Divider  isMargin={"16px 0px"}></Divider> */}
            
              {/* <ManagerIconContainer   selected={profileChecked}>
                <div
                  className="archive-action"
                  onClick={() => setProfileChecked((prev)=>!prev)}
                >
                  {profileChecked
                    ? RecognitionTickIcon()
                    : null}
                </div>
              </ManagerIconContainer> */}
              {/* <div className="completeProfileContainer">
                <div>
                  <div className="completeTitle">Complete your profile</div>
                  <div className="addText">Add your profile details so that client can find you</div>
                </div>
              </div> */}
              <div className="wrapper">
                <CommonButtonPopup height="44px" width="380px" margin="16px 0 0 0" onClick={()=>openPopup()}>
                Complete your profile
                </CommonButtonPopup>
              </div>
      
            </CTACard>}
            {
              <ProfileDetailsPopup showModal={profilePopup}  closeModal={closePopup}  userName={FullName} coachData={coachData}  setStepForPopup={setStepForPopup}  step={step}   editState={editState}  GetCoachProfileData={GetCoachProfileData}   loggedInUserID={loggedInUserID} employeeId={employeeId}    dropdownOpen={dropdownOpen}  toggleDropdown={toggleDropdown}/>
            }
          </div>
    
          <div>
            { coachData?.health_coach_languages.length || coachData?.coaching_style || coachData?.client_type_focus || coachData?.years_of_experience ? 
              <AboutContainer  isFontSize={"18px"} isPadding={"20px"} marginBottom={"8px"} isWidth={"330px"} marginTop={"0px"} style={{marginBottom:"20px"}} >
                <div className="aboutSubContainer">
                  <div className="aboutHeading">Profile language</div>
                  {isEditable ?  <div className="icon" onClick={()=> EditCoachBasicDetails()}>{EditIconBranding()}</div>:null}
                </div>
        
                {coachData?.health_coach_languages.length ? <div className="text"> {coachData?.health_coach_languages?.map((lang) => lang.name).join(", ")}</div> : <div className="no-Data-Found">No data available</div>}
                <Divider isMargin={"16px 0px"}></Divider>
        
                <div className="aboutHeading">Coaching style</div>
                {coachData?.coaching_style ? <div className="text">{coachData?.coaching_style}</div> : <div className="no-Data-Found">No data available</div>}
                <Divider isMargin={"16px 0px"}></Divider>
        
                <div className="aboutHeading">Client type focus</div>
                {coachData?.client_type_focus ?<div className="text">{coachData?.client_type_focus}</div>:<div className="no-Data-Found">No data available</div>}
                <Divider isMargin={"16px 0px"}></Divider>
        
                <div className="aboutHeading">Years of experience</div>
                {coachData?.years_of_experience ? <div className="text">{coachData?.years_of_experience} Years</div>: <div className="no-Data-Found">No data available</div>}
              
              </AboutContainer>
              :   
              coachData?.health_coach_wellness_pillars?.length && coachData?.health_coach_languages?.length ?
                <AboutContainer  isFontSize={"18px"} isPadding={"20px"} marginBottom={"8px"} isWidth={"330px"} marginTop={"0px"} style={{marginBottom:"20px"}} >
                  <div className="aboutSubContainer">
                    <div className="aboutHeading">Profile language</div>
                    {isEditable ?  <div className="icon" onClick={()=> EditCoachBasicDetails()}>{EditIconBranding()}</div>:null}
                  </div>
                  <div className="no-Data-Found">No data available</div>
                </AboutContainer> : null
            }
      
            {coachData?.health_coach_wellness_pillars?.length ?  
              <AboutContainer isFontSize={"18px"} isPadding={"20px"} marginBottom={"8px"} isWidth={"330px"} marginTop={"0px"} >
                <div className="aboutSubContainer">
                  <div className="aboutHeading">Expertise</div>
                  {isEditable ?  <div className="icon" onClick={()=> EditExpertiseDetails()}  >{EditIconBranding()}</div>: null}
                </div>
        
                {coachData?.health_coach_wellness_pillars?.map((item,index,arr)=>(
                  <div key={item.id}> 
                    <div className="heading">{item.pillar_title}</div>
                    {item?.sub_pillars?.map((sub)=>(   <div className="text"  key={sub.id}>{sub?.title}</div>))}
                    {index <  arr.length-1 && <Divider isMargin={"16px 0px"}></Divider>}
                  </div>
                ))}
              </AboutContainer> : 
              coachData?.health_coach_wellness_pillars?.length && coachData?.health_coach_languages?.length ? 
                <AboutContainer isFontSize={"18px"} isPadding={"20px"} marginBottom={"8px"} isWidth={"330px"} marginTop={"0px"} >
                  <div className="aboutSubContainer">
                    <div className="aboutHeading">Expertise</div>
                    {isEditable ?  <div className="icon" onClick={()=> EditExpertiseDetails()}  >{EditIconBranding()}</div>: null}
                  </div>
                  <div className="no-Data-Found">No data available</div>
                </AboutContainer>:null
              
            }
          </div>
         
        </div>)
      }
    </div>
  )
}

export default HealthCoachDashboard;
